<div class="enhanced-dept-field-container">
  <!-- EDITABLE MODE -->
  <div *ngIf="canUpdate" class="editable-mode">
    <!-- Fixed Label with Modal Button -->
    <div class="dept-select-wrapper">
      <p class="dept-field-label">{{fieldLabel}}</p>
      <button
        type="button"
        class="dept-select-button"
        (click)="openSelectionModal()"
        [disabled]="!hasDepartments"
        aria-label="Open department selection">
        <span class="button-text" *ngIf="!hasSelections">Select departments</span>
        <span class="button-text" *ngIf="hasSelections">Change selection</span>
        <ion-icon name="chevron-forward-outline" class="button-icon"></ion-icon>
      </button>
    </div>

    <!-- Selected Items Preview (Chips) -->
    <div class="dept-chips-container" *ngIf="hasSelections">
      <ion-chip
        *ngFor="let dept of getSelectedDepartments()"
        class="dept-chip"
        [attr.aria-label]="'Remove ' + dept.name">
        <ion-label>{{dept.name}}</ion-label>
        <ion-icon
          name="close-circle"
          (click)="removeDepartment(dept.id)"
          class="chip-close-icon"></ion-icon>
      </ion-chip>

      <button
        type="button"
        class="btn-clear-all"
        (click)="clearAllDepartments()"
        aria-label="Clear all departments">
        <ion-icon name="close-circle-outline"></ion-icon>
        Clear all
      </button>
    </div>

    <!-- Empty State (No Selections) -->
    <div class="dept-empty-state" *ngIf="!hasSelections">
      <ion-icon name="business-outline" class="empty-icon"></ion-icon>
      <p class="empty-text">No departments selected</p>
    </div>

    <!-- No Departments Available Warning -->
    <div class="dept-warning" *ngIf="!hasDepartments">
      <ion-icon name="alert-circle-outline" class="warning-icon"></ion-icon>
      <p class="warning-text">No departments available for selection</p>
    </div>
  </div>

  <!-- READ-ONLY MODE -->
  <div *ngIf="!canUpdate" class="readonly-mode">
    <!-- Field Header -->
    <div class="field-header">
      <ion-icon name="business-outline" class="header-icon"></ion-icon>
      <span class="field-label">Department</span>
      <span class="count-badge" *ngIf="hasSelections">{{selectedCount}}</span>
    </div>

    <!-- Selected Departments as Pills -->
    <div class="dept-pills-grid" *ngIf="hasSelections">
      <span class="dept-pill" *ngFor="let dept of getSelectedDepartments()">
        <ion-icon name="checkmark-circle" class="pill-icon"></ion-icon>
        {{dept.name}}
      </span>
    </div>

    <!-- Empty State (No Selections) -->
    <div class="dept-empty-readonly" *ngIf="!hasSelections">
      <ion-icon name="business-outline" class="empty-icon-readonly"></ion-icon>
      <p class="empty-text-readonly">No departments assigned</p>
    </div>
  </div>
</div>
